// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M12 21H21V3H12M12 21H3V3H12M12 21V3M3 12H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"frame"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 21L21 21L21 3L12 3L3 3L3 21H12Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 21H21V3H12M12 21H3V3H12M12 21V3M3 12H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FrameIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'frame',
    ref,
    icon: element,
  },
));

FrameIcon.displayName = 'FrameIcon';

export default FrameIcon;
